/**
 * Configure Shopify.actions so apps/agents open the native cart drawer
 * and emit cart events from the drawer scope.
 *
 * `scripts.liquid` is rendered before `content_for_header`, so
 * `Shopify.actions` may not exist yet. Init on DOMContentLoaded in that case.
 */

function cartDrawer() {
  return (
    document.querySelector('cart-drawer-component#cart-drawer') ??
    document.querySelector('cart-drawer-component')
  );
}

function isOnCartPage() {
  const cartUrl = Theme?.routes?.cart_url || '/cart';
  try {
    return window.location.pathname === new URL(cartUrl, window.location.origin).pathname;
  } catch {
    return window.location.pathname === '/cart' || window.location.pathname.endsWith('/cart');
  }
}

function init() {
  const actions = window.Shopify?.actions;
  if (!actions) return;

  actions.updateCart.configure({
    eventTarget: () => cartDrawer() ?? document,
  });

  actions.openCart.configure({
    async handler() {
      const drawer = cartDrawer();

      if (drawer && typeof drawer.open === 'function') {
        drawer.removeAttribute('hidden');
        drawer.open();
        return;
      }

      if (isOnCartPage()) return;

      window.location.href = Theme?.routes?.cart_url || '/cart';
    },
  });
}

if (window.Shopify?.actions) {
  init();
} else {
  document.addEventListener('DOMContentLoaded', init, { once: true });
}
